











































import { Component, Vue } from 'vue-property-decorator';
import { mdbProgress, mdbBtn, mdbIcon } from '@folky-tools/mdbvue';
import { businessesService, authenticationService, authorizationManagerService, getOrganizationBusinessFrontPageSummaryByBusinessId, getOrganizationBusinessOrderNotViewedCountByBusinessId, getBusinessPricingMaxLevelService } from '@/services';
import { BusinessFrontPageSummary } from '@/models/businesses/business-front-page-summary';
import { capturePwaInstallPrompt } from '@/plugins/pwa-install';

@Component({
    components: {
        mdbProgress,
        mdbBtn,
        mdbIcon,
        NavbarLoggedOut: () => import('@/components/shared/NavbarLoggedOut.vue'),
        SideNavLoggedIn: () => import('@/components/shared/SideNavLoggedIn.vue'),
        NavbarLoggedIn: () => import('@/components/shared/NavbarLoggedIn.vue'),
        FooterPanel: () => import('@/components/shared/FooterPanel.vue'),
        CookieConsentWarning: () => import('@/components/shared/CookieConsentWarning.vue')
    }
})
export default class App extends Vue {
    private navbarClasses: string = '';
    private activePage: string = '';
    private activePageParams: any[] = [];
    private toggle: boolean = false;
    private isCurrentUserAuthenticated: boolean = false;
    private gotoUserDashboardTimer?: NodeJS.Timeout;
    private gotoUserDashboard: boolean = false;
    private canWriteOnlySingleBusiness: boolean = false;
    private authorizedBusinessesIdToEdit: number[] = [];
    private businessFrontPageSummary: BusinessFrontPageSummary | null = null;
    private businessTradeName: string = '';
    private unviewedOrders: number = 0;
    private environment: string | undefined = process.env.NODE_ENV;
    private maxBusinessPricingLevel: number | null = null;

    private async created(): Promise<void> {
        // Registered here, before any route component exists, so the event is not missed while a lazy chunk is still loading.
        window.addEventListener('beforeinstallprompt', capturePwaInstallPrompt);

        this.isCurrentUserAuthenticated = await authenticationService.isAuthenticated;

        this.checkBusinessOwnership();
    }

    private async mounted(): Promise<void> {
        this.gotoUserDashboardTimer = setInterval(() => this.tryToGoToUserDashboard(), 1000 * 10);

        this.$on('toggle', (value: boolean) => {
            this.toggle = value;
        });
        this.$root.$on('change-active-page', (value: string, params: any[]) => {
            this.activePage = value;
            this.activePageParams = params;
        });
        this.$root.$on('changeNavbarClasses', (value: string) => {
            this.navbarClasses = value;
        });
        this.$root.$on('change-business-frontpage-summary', (businessFrontPageSummary: BusinessFrontPageSummary) => {
            this.businessFrontPageSummary = businessFrontPageSummary;
        });
        this.$root.$on('order-viewed', (value: string) => {
            this.checkUnviewedOrders(true);
        });

        this.checkUnviewedOrders(false);

        await authorizationManagerService.refreshPermissions();
    }

    private async updated(): Promise<void> {
        this.isCurrentUserAuthenticated = await authenticationService.isAuthenticated;
        this.checkBusinessOwnership();
        this.checkUnviewedOrders(false);
    }

    private async checkBusinessOwnership(): Promise<void> {
        this.canWriteOnlySingleBusiness = authorizationManagerService.canWriteOnlySingleBusiness;
        this.authorizedBusinessesIdToEdit = authorizationManagerService.authorizedBusinessIdsToEdit;
        if (this.isCurrentUserAuthenticated) {
            if (this.canWriteOnlySingleBusiness && this.businessFrontPageSummary === null) {
                const business = await businessesService.getBusiness(this.authorizedBusinessesIdToEdit[0]);
                this.maxBusinessPricingLevel = business.pricingLevel;
                this.businessTradeName = `${business.tradeName}`;
                this.businessFrontPageSummary = new BusinessFrontPageSummary(await getOrganizationBusinessFrontPageSummaryByBusinessId.execute(this.authorizedBusinessesIdToEdit[0]));
            } else if (!this.canWriteOnlySingleBusiness) {
                this.maxBusinessPricingLevel = await getBusinessPricingMaxLevelService.execute();
            }
        }
    }

    private async checkUnviewedOrders(reset: boolean): Promise<void> {
        this.unviewedOrders = reset ? 0 : this.unviewedOrders;
        if (this.authorizedBusinessesIdToEdit.length < 5 && this.unviewedOrders === 0) {
            this.authorizedBusinessesIdToEdit.forEach(async b => {
                this.unviewedOrders = this.unviewedOrders + (await getOrganizationBusinessOrderNotViewedCountByBusinessId.execute(b));
            });
        }
    }

    private tryToGoToUserDashboard(): void {
        this.gotoUserDashboard = true;
        clearInterval(this.gotoUserDashboardTimer!);
    }

    private async goToUserDashboard(): Promise<void> {
        if (caches) {
            await caches.keys().then(async names => {
                for (const name of names) {
                    await caches.delete(name);
                }
            });
        }
        if (this.isCurrentUserAuthenticated) {
            await authenticationService.logout('/dashboard');
        } else {
            window.localStorage.clear();
            window.location.replace('/dashboard');
        }
    }
}
